import { useCallback } from 'react';
import styled, { css } from 'styled-components';

import { formatBytes, getExtension } from '../../utils/FileControlUtil';
import IconHWP from '../../img/ico_file_32_hwp.png';
import IconSLIDE from '../../img/ico_file_32_slide.png';
import IconSHEET from '../../img/ico_file_32_sheet.png';
import IconWORD from '../../img/ico_file_32_word.png';
import IconFOLDER from '../../img/ico_folder.png';
import IconImage from '../../img/file_image.png';
import { noTextSelect } from '../common/CssCommon';
import { DOC_FORMAT_CONFIG_PREDEFINED } from '../../define/global';
import { NAVERWORKS_DRIVE_TYPE, NAVERWORKS_SUPPORT_IMAGE_EXT } from '../../define/naverworksDefine';
import { convModifiedTime, getFileIcon, isFolder } from '../../utils/NaverWorksUtil';

const Main = styled.div`
  width: 100%;
  height: 100%;
`;

const IMAGE_ICON_WIDTH = 36.5;
const ICON_RIGHT_MARGIN = 11.5;

const HeaderModifyInfo = styled.div`
  width: 111px;
  display: flex;
  align-items: center;
  font-size: 12px;
  ${({ isHeader }) =>
    isHeader &&
    css`
      font-size: 14px;
    `}
`;

const HeaderSize = styled.div`
  width: 70px;
  display: flex;
  align-items: center;
  font-size: 12px;
  ${({ isHeader }) =>
    isHeader &&
    css`
      font-size: 14px;
    `}
`;

const ContentsWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 38px;
  min-height: 38px;
  flex-direction: row;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  ${noTextSelect}
`;

const FileNameArea = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FileName = styled.div`
  font-size: 14px;
  color: #2f3133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  box-sizing: border-box;
`;

const ContentsIconArea = styled.div`
  width: ${IMAGE_ICON_WIDTH}px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${ICON_RIGHT_MARGIN}px;
`;

const ContentsTextAreaMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
`;
const FileNameAreaMobile = styled.div`
  display: flex;
  width: 100%;
  font-size: 14px;
  color: #2f3133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FileNameMobile = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FileInfoAreaMobile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  overflow: hidden;
`;
const FileInfoTextMobile = styled.div`
  font-size: 12px;
  color: #aaadb0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
`;

export default function ListView({ filteringList, isMobile, onClickFolder, openDocument }) {
  return (
    <Main>
      {filteringList &&
        filteringList.map((item) => (
          <ContentsWrapper
            key={item.fileId}
            onClick={() => {
              if (isFolder(item.fileType)) {
                onClickFolder(NAVERWORKS_DRIVE_TYPE.PERSONAL, 'me', item.fileId, item.fileName);
              } else {
                openDocument(NAVERWORKS_DRIVE_TYPE.PERSONAL, 'me', item.fileId);
              }
            }}>
            {isMobile ? (
              <>
                <ContentsIconArea>
                  <img src={getFileIcon(item.fileType, item.fileName, false)} width="32" />
                </ContentsIconArea>
                <ContentsTextAreaMobile>
                  <FileNameAreaMobile>
                    <FileNameMobile>{item.fileName}</FileNameMobile>
                  </FileNameAreaMobile>
                  {isFolder(item.fileType) === false && (
                    <FileInfoAreaMobile>
                      <FileInfoTextMobile>
                        {isFolder(item.fileType) ? '' : convModifiedTime(item.modifiedTime)}
                      </FileInfoTextMobile>
                      <FileInfoTextMobile>
                        {isFolder(item.fileType) ? '' : formatBytes(item.fileSize)}
                      </FileInfoTextMobile>
                    </FileInfoAreaMobile>
                  )}
                </ContentsTextAreaMobile>
              </>
            ) : (
              <>
                <ContentsIconArea>
                  <img src={getFileIcon(item.fileType, item.fileName, false)} width="32" />
                </ContentsIconArea>
                <FileNameArea title={item.fileName}>
                  <FileName>{item.fileName}</FileName>
                </FileNameArea>
                <HeaderModifyInfo>
                  {isFolder(item.fileType) ? '' : convModifiedTime(item.modifiedTime)}
                </HeaderModifyInfo>
                <HeaderSize>{isFolder(item.fileType) ? '' : formatBytes(item.fileSize)}</HeaderSize>
              </>
            )}
          </ContentsWrapper>
        ))}
    </Main>
  );
}
